/**
 * ExecutiveSummaryView Component
 *
 * View wrapper for Executive Summary.
 * Shows high-level ROI and business metrics dashboard.
 */

import { useState, useEffect } from 'react'
import { ArrowLeft, Loader2, AlertCircle, TrendingUp } from 'lucide-react'
import { ExecutiveSummary } from '../reports'
import { getDiscoveryResults } from '../../services/codeAnalysisService'
import './SharedReportView.css'

function ExecutiveSummaryView({ onBack, analysisContext }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [discoveryData, setDiscoveryData] = useState(null)

  const jobContext = analysisContext

  // Fetch discovery data
  useEffect(() => {
    const fetchData = async () => {
      if (!jobContext?.jobs?.discovery_job_id) {
        setError('No discovery data found. Please run Discovery workflow first.')
        setLoading(false)
        return
      }

      setLoading(true)
      setError(null)

      try {
        const data = await getDiscoveryResults(jobContext.jobs.discovery_job_id)
        setDiscoveryData(data)
      } catch (err) {
        console.error('Failed to fetch discovery data:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [jobContext])

  return (
    <div className="report-view">
      {/* Header */}
      <div className="report-header">
        <button onClick={onBack} className="back-btn">
          <ArrowLeft size={20} />
          Back to Reports
        </button>
        <div className="header-title">
          <TrendingUp size={24} />
          <h1>Executive Summary</h1>
        </div>
      </div>

      {/* Content */}
      <div className="report-content">
        {loading ? (
          <div className="loading-state">
            <Loader2 size={32} className="spin" />
            <p>Loading executive summary...</p>
          </div>
        ) : error ? (
          <div className="error-state">
            <AlertCircle size={32} />
            <p>{error}</p>
            <button onClick={onBack} className="secondary-btn">
              Go Back
            </button>
          </div>
        ) : (
          <ExecutiveSummary
            discoveryData={discoveryData}
            title="Executive Summary"
          />
        )}
      </div>
    </div>
  )
}

export default ExecutiveSummaryView
